import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { removeDelay: Number }
  
  connect() {
    if (this.hasRemoveDelayValue) {
      this.timeout = setTimeout(() => {
        this.remove()
      }, this.removeDelayValue)
    }
  }
  
  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
  
  remove() {
    this.element.style.transition = "opacity 0.3s ease-out"
    this.element.style.opacity = "0"
    
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}